import { transformOrganizations } from './api';
import { denormalize } from '@eb/transformation-utils';

export const MOCK_ORGANIZATION_ID = '226753266189';
export const MOCK_ORGANIZATION_NAME = 'Blorg Org';
export const MOCK_ORGANIZATION_IMAGE_ID = '36897640';
export const MOCK_ORGANIZATION_IMAGE = {
    id: MOCK_ORGANIZATION_IMAGE_ID,
    url: 'https://path/to/image.png',
    original: {
        url: 'https://path/to/original/image.png',
        height: 1067,
        width: 3568,
    },
};
export const MOCK_ORGANIZATION_RESPONSE = {
    id: MOCK_ORGANIZATION_ID,
    name: MOCK_ORGANIZATION_NAME,
    vertical: 'general',
    locale: 'de_AT',
    image_id: MOCK_ORGANIZATION_IMAGE_ID,
    image: MOCK_ORGANIZATION_IMAGE,
};
export const MOCK_ORGANIZATIONS_RESPONSE = {
    organizations: [
        MOCK_ORGANIZATION_RESPONSE,
        {
            id: '888888',
            name: 'Corgi Org',
            vertical: 'music',
            locale: null,
            image_id: '',
        },
        {
            id: '777777',
            name: 'Porgy Org',
            vertical: 'general',
            locale: 'en_US',
            image_id: '',
        },
    ],
};

export const ORGS_BY_USER_SUCCESS_RESPONSE = {
    organizations: [
        {
            id: '1',
            name: 'Organization 1',
        },
        {
            id: '2',
            name: 'Organization 2',
        },
        {
            id: '3',
            name: 'Organization 3',
        },
    ],
};

export const MOCK_NORMALIZED_ORGANIZATIONS = transformOrganizations(
    MOCK_ORGANIZATIONS_RESPONSE.organizations,
);
export const MOCK_ORGANIZATION_ENTITIES =
    MOCK_NORMALIZED_ORGANIZATIONS.organizationEntities;
export const MOCK_ORGANIZATION_IDS =
    MOCK_NORMALIZED_ORGANIZATIONS.organizationIds;
export const MOCK_ORGANIZATIONS = denormalize(
    MOCK_ORGANIZATION_IDS,
    MOCK_ORGANIZATION_ENTITIES,
);
export const MOCK_CURRENCY_FORMAT = '¤ #,##0.00';
